import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 9v4","key":"svg-0"}],["path",{"d":"M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0","key":"svg-1"}],["path",{"d":"M12 16h.01","key":"svg-2"}]]

const IconAlertTriangle = createReactComponent('outline', 'alert-triangle', 'AlertTriangle', __iconNode);

export default IconAlertTriangle;